import { CommonModule } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { ColdSinusFluIconSvgComponent } from "../../../../../assets/svg/cold-sinus-flu-icon";
import { PinkEyeIconSvgComponent } from '../../../../../assets/svg/pink-eye-icon';
import { YeastInfectionIconSvgComponent } from '../../../../../assets/svg/yeast-infection-icon';
import { UrinaryTractInfectionIconSvgComponent } from '../../../../../assets/svg/urinary-tract-infection-icon';
import { StomachIssuesIconSvgComponent } from '../../../../../assets/svg/stomach-issues-icon';
import { SkinConditionIconSvgComponent } from '../../../../../assets/svg/skin-condition-icon';
import { EarPainSvgComponent } from '../../../../../assets/svg/ear-pain-icon';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-ask-a-doctor-option-card-mobile',
  imports: [
    CommonModule, TranslateModule, MatCardModule, MatButtonModule, 
    ColdSinusFluIconSvgComponent,
    PinkEyeIconSvgComponent,
    YeastInfectionIconSvgComponent,
    UrinaryTractInfectionIconSvgComponent,
    StomachIssuesIconSvgComponent,
    SkinConditionIconSvgComponent,
    EarPainSvgComponent],
  templateUrl: './ask-a-doctor-option-card.component.html',
  styleUrl: '../../../../../styles.css'
})
export class AskADoctorOptionCardComponent {
  @Input() title!: string;
  @Input() deepLink!: string;
  @Input() deepLinkNoAuth!: string;
  @Input() symptomID!: string;
  @Input() photoUrl!: string;
  @Input() waitTime!: string;
  @Input() locale: string | null = null;
  @Input() isPlus: boolean | null = false;

  public soonAsText: string = 'AS_SOON_AS';
  public minutesText: string = 'MINUTES';
  public startNowText: string = 'START_NOW';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem("locale") || 'en-US'); // Default to 'en-US' if no locale is provided
  }

  ngOnInit() {
    this.translate.get('AS_SOON_AS').subscribe((translated: string) => {
      this.soonAsText = translated;
    });

    this.translate.get('MINUTES').subscribe((translated: string) => {
      this.minutesText = translated;
    });

    this.translate.get('START_NOW').subscribe((translated: string) => {
      this.startNowText = translated;
    });
  }

  startNow() {
    const eptID = sessionStorage.getItem("eptID");
    const isMobile = window.location.href.includes('mobile');

    if (eptID == null || eptID == undefined || eptID == "") {
      this.startNowUnAuth(isMobile);
    }
    else {
      this.startNowAuth();
    } 
  }

  startNowUnAuth(isMobile: boolean) {
    var deepLinkURL = '';
    if (isMobile == true) {
      deepLinkURL = environment.mobile_fdi_deep_link_base_url; // For Plus users, use the mobile deep link      
      deepLinkURL += `webid=${this.deepLinkNoAuth}&iosid=${this.deepLinkNoAuth}&androidid=${this.deepLinkNoAuth}`; // Append the specific deep link for the QuickCare option
    }
    else {
      deepLinkURL = environment.web_quickcare_unauth_deep_link_base_url; // For web users, use the web deep link
      deepLinkURL += `/conditions/${this.symptomID}`; // Append the specific symptom path
      deepLinkURL += this.locale == 'es-US' ? '?l=es' : '?l=en'; // Append language parameter for web link
    }

    var platform = isMobile ? 'mobile-plus' : 'web';
    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'get-care-now', subfeature: 'QuickCare', platform: platform }); // log as web event
  
    console.log("Start now clicked (QuickCare)");
    console.log(deepLinkURL);
    
    window.location.href = deepLinkURL;
  }

  startNowAuth() {
    var deepLinkURL = '';
    const isPlus = sessionStorage.getItem("isPlus") != null ? sessionStorage.getItem("isPlus") === 'true'  : null;

    // TO-DO: Implement building the deep link based on the deep link provided from API response
    // once FDI records are built for each QuickCare option.
    
    // deepLinkURL = this.isPlus 
    //   ? environment.mobile_fdi_deep_link_base_url
    //   : environment.epic_fdi_deep_link_base_url; //  For non-Plus users, use the epic deep link

    // if (this.deepLink != null && this.deepLink != undefined && this.deepLink != "") {
    //   deepLinkURL += this.deepLink; // Append the specific deep link for the QuickCare option
    // }
    // else {  // If no specific deep link is provided, use the generic one
    //   deepLinkURL = this.isPlus 
    //   ? environment.mobile_quickcare_deep_link_base_url // For Plus users, use the mobile deep link
    //   : environment.epic_quickcare_deep_link_base_url; //  For non-Plus users, use the epic deep link
    // }

    // For now, we will use the standard QuickCare deep link
    if (isPlus == null) { 
      deepLinkURL = environment.web_fdi_deep_link_base_url; // Default to web deep link if isPlus is null

      if (this.photoUrl != null && this.photoUrl != undefined && this.photoUrl != "") {
        if (this.photoUrl.includes('Cold-Sinus-Flu')) {
          deepLinkURL += environment.fdi_option_qc_cough;
        } else if (this.photoUrl.includes('Skin-Condition')) {
          deepLinkURL += environment.fdi_option_qc_skin;
        } else if (this.photoUrl.includes('Pink-Eye')) {
          deepLinkURL += environment.fdi_option_qc_pinkeye;
        } else if (this.photoUrl.includes('Stomach-Issues')) {
          deepLinkURL += environment.fdi_option_qc_stomach;
        } else if (this.photoUrl.includes('Urinary-Tract-Infection')) {
          deepLinkURL += environment.fdi_option_qc_uti;
        } else if (this.photoUrl.includes('Yeast-Infection')) {
          deepLinkURL += environment.fdi_option_qc_yeast;
        } else {
          // if no match, default to standard quickcare deep link
          deepLinkURL = environment.web_quickcare_deep_link_base_url;
        }
      }
      else {
        deepLinkURL = environment.web_quickcare_deep_link_base_url;
      }


      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'QuickCare', platform: 'web' }); // log as web event
    }
    else {
      deepLinkURL = isPlus 
        ? environment.mobile_fdi_deep_link_base_url // For Plus users, use the mobile deep link
        : environment.epic_fdi_deep_link_base_url; //  For non-Plus users, use the epic deep link

        if(this.deepLink != null && this.deepLink != undefined && this.deepLink != "") {
          deepLinkURL += "webid=" + this.deepLink + "&iosid=" + this.deepLink + "&androidid="+ this.deepLink ; // Append the specific deep link for the QuickCare option
        }
        else {
          // if no specific deep link is provided, use the generic one
          deepLinkURL = isPlus 
        ? environment.mobile_quickcare_deep_link_base_url // For Plus users, use the mobile deep link
        : environment.epic_quickcare_deep_link_base_url; //  For non-Plus users, use the epic deep link
        }
        
        var mobilePlatform = isPlus ? 'mobile-plus' : 'mobile-standard';

        this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'QuickCare', platform: mobilePlatform }); // log as mobile event
    }

    console.log("Start now clicked (QuickCare)");
    console.log(deepLinkURL);


    window.location.href = deepLinkURL;

  }
}
